export enum ExportAnalyticsEnum {
  TrafficAwareness = 'trafficAwareness',
  ContentEngagement = 'contentEngagement',
  ContentTopClicks = 'contentTopClicks',
  ProductEngagement = 'productEngagement',
}
